export default __webpack_public_path__ + "static/media/loader.5a386d55.svg";